import React, { useEffect, useState } from "react";
import { BaseElementProps } from "elements/types";
import { Panel } from "@alm/flow-ds/components";
import RenderElements from "components/Forms/RenderElements";
import { PanelElement } from "records/Element";
import { useDisplayElement } from "components/Forms/Element";
import { useElementsGroups } from "elements/RootForm/RootForm";
import Group from "elements/RootForm/Group";
import { useSelector } from "react-redux";
import { getFormLayout } from "data/form/formSelectors";
import { State } from "data";

function PanelContainer({
	fid,
	traversal,
	label,
	rowIndex,
	uuid,
	index,
	loadCollapsed,
	elements,
}: BaseElementProps & PanelElement) {
	const { eid } = useDisplayElement({ rowIndex, uuid, index });
	const { groups } = useElementsGroups(elements);
	const formLayout = useSelector((state: State) => getFormLayout(state, fid));

	const MOBILE_WIDTH = 768;
	const [width, setWidth] = useState(window.innerWidth);
	const handleWindowSizeChange = () => setWidth(window.innerWidth);

	useEffect(() => {
		window.addEventListener("resize", handleWindowSizeChange);
		return () => {
			window.removeEventListener("resize", handleWindowSizeChange);
		};
	}, []);

	return (
		<Panel
			title={label}
			id={eid}
			isOpen={!loadCollapsed}
			className="elem-panel elem">
			{traversal && formLayout?.fullWidth && width >= MOBILE_WIDTH ? (
				<Group
					groups={groups}
					elements={elements}
					traversal={traversal}
					fullWidth={formLayout.fullWidth}
					fid={fid}
				/>
			) : (
				<RenderElements fid={fid} traversal={traversal} />
			)}
		</Panel>
	);
}

export default React.memo(PanelContainer);
